export default class SplitSeatsModal {
    constructor() {
        this.el = $('#no-tickets-modal');
        if (!this.el.length) {
            return false;
        }
        this.accepted = false;
        this.onAcceptSplitSeats = this.onAcceptSplitSeats.bind(this);
        this.init();
    }

    init() {
        this.el.find('a.accept-split-seats').on('click', this.onAcceptSplitSeats);
    }

    onAcceptSplitSeats() {
        if (this.accepted) {
            return false;
        }
        this.accepted = true;
        this.el.remove();
        return false;
    }
}